import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useFinalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '600px',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
      },
    },
    buttonSection: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '50px',
    },
  })
);
